// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\people.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\people.tsx");
  import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

import { PeopleSection } from "~/components/shared/PeopleSection";
export const meta = () => {
  return [{
    title: "People | Nomadics"
  }, {
    name: "description",
    content: "Meet our creative community"
  }];
};
export default function People() {
  return <div>
      <PeopleSection />
    </div>;
}
_c = People;
var _c;
$RefreshReg$(_c, "People");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;